export default __webpack_public_path__ + "static/media/ava.78fc86c8.jpeg";